/** Locale number with a fixed max precision, or an em dash when missing. */
export function num(v, digits = 0) {
  return v == null ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: digits });
}
